package one.healthium.log_food.domain

data class FoodModel(
    val product: String,
    val emoji: String,
    val description: String,
    val calories: Float,
    val fat: Float,
    val carbohydrates: Float,
    val fiber: Float,
    val protein: Float,
    val tablespoon: Float?,
    val cups: Float?,
    val pieces: Float?,
    val isLiquid: Boolean,
)
